import {
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
  ChangeDetectionStrategy,
} from '@angular/core';
import { LineChartDataPoints, Spline } from '@interfaces';
import { GenericChartComponent } from '../generic-chart/generic-chart.component';

@Component({
  selector: 'fip-bar-chart',
  templateUrl: './bar-chart.component.html',
  styleUrls: ['./bar-chart.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class BarChartComponent
  extends GenericChartComponent
  implements OnInit, OnChanges
{
  @Input() dataPoints: Array<LineChartDataPoints | Spline> = [];
  @Input() ticksuffix = '';
  @Input() orientation: 'v' | 'h' = 'v';
  @Input() text: string[] = [];
  @Input() hoverinfo: 'text' | 'none' = 'text';

  override refreshGraph() {
    const x = this.dataPoints[0].x;
    const y = this.dataPoints[0].y;
    const trace = this.createTrace(x, y);

    this.data = [];
    this.configXAxis(x);

    this.data = [trace, ...this.dataPoints.slice(1)];
    this.layout.shapes = [...this.shapes];

    this.layout = Object.assign({}, this.layout, {
      width: this.width,
      margin: {
        t: 0,
        l: 0,
        r: 0,
      },
      font: {
        size: 11,
      },
      orientation: this.orientation,
      xaxis: {
        title: { text: this.xTitle },
        ticktext: this.xTicksLabels,
        tickvals: this.xTicksVals,
        autorange: true,
        fixedrange: true,
      },
      yaxis: {
        title: { text: this.yTitle },
        autorange: true,
        ticksuffix: this.ticksuffix,
        fixedrange: true,
      },
    });
    this.layout.xaxis.ticktext = this.xTicksLabels;
    this.layout.xaxis.tickvals = this.xTicksVals;
    if (this.tickAngle) {
      this.layout.xaxis.tickangle = this.tickAngle;
    }
    this.configLegend();
  }

  configXAxis(x: number[]) {
    let minXValue = Math.min(...x);
    let maxXValue = Math.max(...x);

    this.dataPoints.forEach((shape) => {
      if ((shape as Spline).x) {
        minXValue = Math.min(...shape.x, minXValue);
        maxXValue = Math.max(...shape.x, maxXValue);
      }
    });

    this.shapes.forEach((shape) => {
      if (shape.x0 && shape.x1) {
        minXValue = Math.min(shape.x0, shape.x1, minXValue);
        maxXValue = Math.max(shape.x0, shape.x1, maxXValue);
      }
    });

    this.layout.xaxis.range = [minXValue, maxXValue];
    this.layout.xaxis.ticktext = x.map((val) => val.toString());
    this.layout.xaxis.tickvals = x;
  }

  createTrace(x: number[], y: number[]) {
    const trace = {
      name: '',
      x,
      y,
      marker: {
        color: this.colorSecondary,
        line: {
          color: this.colorPrimary,
          width: 1,
        },
      },
      type: 'bar',
      text: this.text,
      orientation: this.orientation,
      hoverinfo: this.hoverinfo,
    };

    return trace;
  }

  override ngOnChanges(changes: SimpleChanges) {
    if (changes['dataPoints']) {
      this.refreshGraph();
    }
  }
}
